<template>
  <!-- <div v-if="user.core_role_id < 11 && user.core_role_id > 0 && user.core_role_code != 'business-partner'"> -->
  <!-- Se bloque el acceso del rol business a HT temporalmente hasta que se tenga listo el módulo para este rol -->
    <div v-if="user.core_role_id < 11 && user.core_role_id > 0 && user.core_role_code" >
    <HeadingUserVP1 />
  </div>
  <div v-else class="row">
    <div class="col-md-6 ml-auto">
        <div class="
            cont-heading
            d-flex
            justify-content-between
            align-items-center

            float-right
          ">
          <div class="">
<!--            <ChangeVersion v-if="user.core_role_id == 2" />-->
            <!--h1 class="text-uppercase mb-0">{{title}}</h1-->
            <!-- Este contenido debe ser dinámico -->
          </div>
          <div class="ml-3 d-flex align-items-center"></div>

          <div class="cont-user-info ml-3 d-flex align-items-center">
            <div class="info_day">
              <img src="@/assets/images/icons/icon_callendar.svg" /><span class="label-regular"
                style="color: #0075ff; margin-left: 8px">
                {{ this.fecha }}</span>
            </div>
            <img src="@/assets/images/icons/logo_people_master.svg" />
            <div class="cont-symbol">
              <b-button v-b-toggle.sidebar-right size="lg" class="notification" variant="light">
                <!--span class="icon-bell"></span-->
                <img src="@/assets/images/icons/icon-bell.svg" />
                <span class="badge" v-show="this.unread > 0">{{
                    this.unread
                }}</span>
              </b-button>
              <b-sidebar id="sidebar-right" title="NOTIFICACIONES" right backdrop shadow>
                <div class="px-5 py-5" style="background-color: #ffffff">
                  <div v-for="data in this.notificationRol" :key="data.notification_id">
                    <a href="#" @click="routeTo(data.license_id, data.notification_id)">
                      <div v-if="data.read_at != 'null'">
                        <div class="row" style="
                            margin-left: 0px;
                            margin-right: 0px;
                            background-color: #ffffff;
                          ">
                          <div class="col-7 mb-md-0">
                            <p class="text">{{ data.time }}</p>
                          </div>
                          <div class="row">
                            <div class="col-12 mb-md-0" align="left" style="background-color: #ffffff">
                              <p class="text">{{ data.text }}</p>
                            </div>
                          </div>
                          <div class="col-12 mb-md-0" style="background-color: #ffffff">
                            <p class="text">
                              <b>Leido: {{ data.read_at }}</b>
                            </p>
                          </div>
                          <div class="row">
                            <div class="col-12 mb-md-0" align="left" style="background-color: #ffffff">
                              <img src="@/assets/images/icons/bar2.svg" />
                            </div>
                          </div>
                        </div>
                        <div class="col-5 mb-md-0" align="right" style="background-color: #ffffff">
                          <p class="text">Solicitud: {{ data.license_id }}</p>
                        </div>
                      </div>
                      <div v-else>
                        <div class="row" style="background-color: #eae8e4">
                          <div class="col-7 mb-md-0 mt-2">
                            <p class="text2">
                              <b>{{ data.time }}</b>
                            </p>
                          </div>
                          <div class="col-5 mb-md-0" align="right">
                            <p class="text2">
                              <b><u>Solicitud: {{ data.license_id }}</u></b>
                            </p>
                          </div>
                          <div class="col-12 mb-md-0" align="left">
                            <p class="text2">{{ data.text }}</p>
                          </div>
                        </div>
                        <div class="row" style="background-color: #eae8e4">
                          <div class="col-12 mb-md-0" align="left">
                            <p class="text2"><b>**Sin leer**</b></p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 mb-md-0" align="left">
                            <img src="@/assets/images/icons/bar2.svg" />
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </b-sidebar>
            </div>
          </div>

          <div class="cont-txt" style="    align-items: center; display: flex;">
            <object :data="serverPath + '/' + getAttributeUserData('image')" style="border: 1px solid #3FFFFF;
    border-radius: 16px; width:32px;height:32px; vertical-align: middle;margin-left:5px;" type="image/jpeg" @error="imageLoadError"
              onerror="this.style.border='0';">
              <span class="cont-txt-img">
                <img class="" src="../../assets/images/login/avatar-small.svg">
              </span>
            </object>

            <b-dropdown toggle-class="text-decoration-none" variant="link" size="lg" no-caret style="z-index: 5;">
              <template #button-content>
                <p class="tbl_header line-clamp mb-0 w-20" style="color: #263238;" align="left">
                  <b class="d-none d-md-inline-block"> {{ user.name }}</b>
                  <img class="centerImg1" src="@/assets/images/icons/chevron-down.svg">
                </p>
                <p class="label-regular mb-0 pr-5 d-none d-md-flex " style="color: #78909C;">{{ user.position }}</p>
              </template>
              <b-dropdown-item>
                <router-link to="/profile" class="menu-button">
                  <p class="name text-capitalize mb-0">Configurar perfil</p>
                </router-link>
              </b-dropdown-item>
              <b-dropdown-item @click="closeSession">
                <p class="name text-capitalize mb-0">Cerrar sesión</p>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      <!-- .cont-user-info -->
    </div>
    <!-- .cont-heading -->
  </div>
  <!-- .col -->
  <!-- .row -->
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import serverConfig from "@/services/config";
// import ChangeVersion from "./ChangeVersion.vue";
import HeadingUserVP1 from "./HeadingUserVP1.vue";
import { clear } from '@/common/helps/local-storage'
export default {
  serverPath: serverConfig.permisosURL,
  name: "HeadingUser",
  components: {
    // ChangeVersion,
    HeadingUserVP1
  },
  props: {
    title: {
      type: String,
      default: "Virtual Partner",
    },
  },
  data() {
    return {
      serverPath: serverConfig.permisosURL,
      notificationRol: [],
      unread: 0,
      fecha: new Date(),
      Urlimage:"../../assets/images/login/avatar-small.svg",
    };
  },
  beforeMount() {
    // if(typeof  UserrData != 'undefined') this.Urlimage="serverPath + '/' + userData.image";
    
//     try {
//       if(userData != 'undefined' || userData !="") this.Urlimage="serverPath + '/' + userData.image";
// } catch (err) {
//   // 👇️ This runs
//   console.log('Error2: ', err.message);
// }
     this.actGetNotifications().then(() => {
      this.unread = this.notifications.data.unread;
      for (let i = 0; i < this.notifications.data.notifications.length; i++) {
        let stringJsonTmp = this.notifications.data.notifications[i].data;
        let stringJson = stringJsonTmp.substring(0, stringJsonTmp.length - 1); // Elimina la '}'
        stringJson +=
          ',"read_at":"' +
          this.notifications.data.notifications[i].read_at +
          '"';
        stringJson +=
          ',"time":"' + this.notifications.data.notifications[i].time + '"}';
        this.notificationRol.push(JSON.parse(stringJson));
      }
    });

    var date = new Date();
    const months = [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ];
    const formatDate = (date) => {
      let formatted_date =
        date.getDate() +
        "-" +
        months[date.getMonth()] +
        "-" +
        date.getFullYear();
      return formatted_date;
    };
    this.fecha = formatDate(date);
  },
  computed: {
    ...mapState("modCore", ["user"]),
    ...mapState("modRequest", ["notifications"]),
    ...mapState("modCore", ["user", "profile", "loadingOn"]),
    capitalize: function () {
      return this.user.created_at.substring(0, 10);
    }
  },
  methods: {
    ...mapMutations("modCore", ["setUser"]),
    ...mapActions("modRequest", ["actGetNotifications", "actUpdateStateNtftn"]),

    closeSession() {
      // this.setUser("");
      // localStorage.setItem("token", "");
      // localStorage.removeItem("employee");
      clear()
      this.$router.push({ path: "/" });
    },

    routeTo(idSol, id) {
      this.actUpdateStateNtftn({ id });

      if (this.user.core_role_id === 1) {
        // Rol Solicitante
        this.$router.push({ path: "/consulrequest/" + idSol });
      }
      if (this.user.core_role_id === 2 || this.user.core_role_id === 7) {
        // Rol RRLL Tiquetes
        this.$router.push({ path: "/approverTks/" + idSol });
      }
      if (this.user.core_role_id === 3) {
        // Rol aprobador solicitud
        this.$router.push({ path: "/approverSol/" + idSol });
      }
    },
    imageLoadError(event) {
      event.target.src = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.line-clamp {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.cont-heading {
  h1 {
    font-size: 18px;

    @media (min-width: 768px) {
      font-size: 24px;
    }
  }

  a:hover {
    color: rgb(39, 39, 39);
  }

  .cont-user-info {
    .cont-txt {
      .name {
        color: #1c3a4e;
        font-weight: 500;
        font-size: 12px;
      }

      .desc {
        color: #454545;
        font-size: 10px;
      }
    }
    .cont-symbol {
      border-right: 2px solid #cfd8dc;
      padding: 0 10px;
      margin-left: 2px;
    }
  }
  .cont-txt-img{
    width: 36px;
    height: 36px;
    display: inline-block;
    vertical-align: middle;
    border-width: 2px;
    border-style: solid;
    border-color: #00A4AC;
    border-radius: 50%;
    position: absolute;
    z-index: 3;
    margin-left: 5px;
    img{
      position: absolute;
      z-index: 1 ;
      border-radius: 50%;
    }
  }
  .notification {
    position: relative;
    display: inline-block;
    border-radius: 50%;
  }

  .notification .badge {
    position: absolute;
    top: -2px;
    right: -7px;
    padding: 4px 4px 2px 4px;
    border-radius: 4px;
    background-color: red;
    color: white;
    font-size: 9px;
  }

  .text {
    background: #ffffff;
    color: #454545;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 12px;
    line-height: 12px;
  }

  .text2 {
    background-color: #eae8e4;
    color: #454545;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 12px;
  }

  .centerImg1 {
    width: 10px;
    height: 10px;
    //position: absolute;
    //left: 50%;
    top: 100%;
    //margin-left: -8px;
    margin-top: 10px;
    float: right;
    //clear: right;
  }

  .info_day {
    /* Auto layout */

    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    padding: 8px;

    position: static;
    //width: 160px;
    height: 32px;
    left: 4px;
    top: 4px;

    /* highlight/info/background */

    background: #e6f7ff;
    border-radius: 100px;

    /* Inside auto layout */

    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 10px 12px;
  }
}

.reloj-letras {
  position: absolute;
  top: 21%;
  left: 10%;

  /* Subtítulos */
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 30px;
  /* Neutral / White */
  color: #ffffff;
}

.reloj-letras {
  position: absolute;
  top: 21%;
  left: 10%;

  /* Subtítulos */
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 30px;
  /* Neutral / White */
  color: #ffffff;
}

.reloj-letras {
  position: absolute;
  top: 21%;
  left: 10%;

  /* Subtítulos */
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 30px;
  /* Neutral / White */
  color: #ffffff;
}
</style>